export default "__VITE_ASSET__594c8729__"